module.exports = __webpack_public_path__ + "img/benefit-card-2-desktop.0ab43054.png";